import type {ConnectElementConfig} from '../ConnectElementList';

export const EditPayoutDestinationConfig: ConnectElementConfig = {
  Component: () =>
    import(
      /* webpackChunkName: "EditPayoutDestination" */
      '../../../components/Account/PayoutInformation/PayoutSchedule/EditPayoutDestination'
    ),
  enabledKey: 'payouts',
  releaseState: 'internal',
  sentryTeam: 'accounts_ui',
  teamOwner: 'connected-account-experiences-eng',
  description: "Payout component's entry point to edit payout destination",
  friendlyName: 'Payouts entry point: edit payout destination',
};
